export interface PlataformGuideResponse {
  label: {
    icon: string;
    text: string;
  };
  videoUrl: string;
  isFirstTime: boolean;
}

export enum PlataformGuidePlace {
  Studeren = 'studeren',
  Oefenen = 'oefenen',
  Theory = 'theory',
  Opbouw = 'opbouw',
  TableOfContents = 'table of contents',
  Homepage = 'homepage',
}
